module.exports = __webpack_public_path__ + "img/img6.dde57f11.jpg";